import React from "react";
import { useSelector } from "react-redux";

import { getMiddlewarePartners } from "../../redux/selectors/partnerCenterSelectors";
import { MiddlewarePartner } from "../../server/partnerCenter/models/middlewarePartner";
import { GdkMiddlewareDropdown } from "./GdkMiddlewareDropdown";

export type MiddlewarePartnerDropdownProps = {
  currentMiddleware: MiddlewarePartner | undefined;
  setCurrentMiddleware: (seller: MiddlewarePartner) => void;
};

export const MiddlewarePartnerDropdown = ({
  currentMiddleware,
  setCurrentMiddleware,
}: MiddlewarePartnerDropdownProps) => {
  const middlewares = useSelector(getMiddlewarePartners);

  const handleMiddlewareChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedSeller = middlewares.find(middleware => middleware.id === event.target.value);
    if (selectedSeller) {
      setCurrentMiddleware(selectedSeller);
    }
  };

  if (!middlewares || middlewares.length === 0) {
    return null;
  }

  return (
    <GdkMiddlewareDropdown
      currentValue={currentMiddleware?.id || ""}
      onChange={handleMiddlewareChange}
    >
      {middlewares.map(middleware => (
        <option key={middleware.id} value={middleware.id}>
          {middleware.name}
        </option>
      ))}
    </GdkMiddlewareDropdown>
  );
};
